import { RootState } from 'store';
import { IDocument } from 'types/documents';

export const documentsSelector = (state: RootState): IDocument[] => state.documents.allDocuments;
export const employeeDocumentsSelector = (state: RootState): IDocument[] => state.documents.employeeDocuments;
export const getDocumentsErrorSelector = (state: RootState): boolean => state.documents.getDocumentsError;

export const documentsLoadingSelector = (state: RootState): boolean => state.documents.loading;
